import React from 'react'
import Header from '../../Compoents/Header'
import Appoinment from './HomeInner/Appoinment'
import LatestBlog from './HomeInner/LatestBlog'
import Footer from '../../Compoents/Footer'
import BannerSlider from './HomeInner/BannerSlider'
import TestimonialSlider from './HomeInner/FAQSlider'
import AboutSection from './HomeInner/AboutSection'
import { OurTherapeuticSpecialties } from '../Aboutus/Therapeutic/TherapeuticSpecialties'
import ResourceSection from './HomeInner/Resource'
import { Link } from 'react-router-dom'
import AcronymsAbbreviationsHome from './HomeInner/AcronAbbreviations'

const Home = () => {
  return (
    <>
        <Header/>
        <main class="home-2__background">

  <BannerSlider/>

  {/* About Us */}
  <AboutSection/>
    {/* About Us end */}

    {/* How We Work */}
    <section class="wellness-expertise section-space__bottom">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="wellness-expertise__content">
                    <h5 class="section__subtitle color-theme-primary mb-15 mb-xs-10 title-animation"><img src="assets/imgs/ask-quesiton/heart.png" alt="icon not found" class="img-fluid"/> How We Work </h5>
                        <h2 class="section__title mb-15 mb-xs-10  title-animation">As your clinical service partner, our dedicated expert team will:</h2>
                  
                        <ul class="wellness-expertise__content__list py-5">
                            <li><i class="fa-solid fa-check"></i> Develop a clinical and regulatory-compliant strategy for your medical device</li>
                            <li><i class="fa-solid fa-check"></i>Create a comprehensive strategic plan and budget overview</li>
                            <li><i class="fa-solid fa-check"></i>Ensure your study meets all ISO 14155 and Notified Body (NB) compliance standards</li>
                            <li><i class="fa-solid fa-check"></i>Assist in preparing or reviewing your clinical trial protocol</li>
                        </ul>
                        <Link to="/how-we-work" class="rr-btn position-relative overflow-hidden">
                            <div class="panel wow"></div>
                            <span class="btn-wrap">
                                <span class="text-one">Read More <i class="fa-solid fa-plus"></i></span>
                                <span class="text-two">Read More <i class="fa-solid fa-plus"></i></span>
                            </span>
                        </Link>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="wellness-expertise__media">
                        <img src="./assets/imgs/wellness-expertise/wellness-expertise.png" class="img-fluid" alt="image not found"/>

                        <div class="wellness-expertise__media__box">
                            <div class="wellness-expertise__media__box-icon">
                                <img class="img-fluid" src="assets/imgs/wellness-expertise/note.svg" alt="icon not found"/>
                            </div>
                            <div class="wellness-expertise__media__box-text">
                                <h3><span class="odometer" data-count="90">0</span>%</h3>
                                <h6>Success Case</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* How We Work end  */}

    {/* Solutions */}
    <section class="service-4 section-space__bottom-100">
        <div class="container">
        <div class="col-lg-12">
                    <div class="">
                    <h5 class="section__subtitle color-theme-primary mb-15 mb-xs-10 title-animation"><img src="assets/imgs/ask-quesiton/heart.png" alt="icon not found" class="img-fluid"/>Solutions </h5>
                        <h3 class="section__title mb-15 mb-xs-10  title-animation">Medical Device Manufacturers </h3>
                        <p class="mb-6">Our team members with expertise in CROs and medical devices work together to provide the most effective solutions for you. With years of industry expertise, our team of multidisciplinary specialists is well-equipped to deliver excellent regulatory and high-quality services in a timely manner. </p>
                    </div>
                </div>
            <div class="row mb-minus-30" >
                <div class="col-xl-4 col-lg-4 col-md-6">
                    <div class="service-4__item mb-30">
                        <div class="service-4__item-icon mb-40 mb-xs-20">
                            <img src="assets/imgs/service-4/services__item-1.png" alt="icon not found"/>
                        </div>
                        <div class="service-4__item-text">
                            <h4 class="mb-15 mb-xs-10 title-animation"><a >Notified Body Transition</a></h4>
                            <p>We offer a variety of solutions to efficiently manage transition projects. While each transition project is unique, our process remains consistent </p>
                            <li>QMS Improvement & Gap identification</li>
                            <li>Fill up the Gap by Medical Writing</li>
                            <li>Medical Device Registration</li>
                            <br />
                            <br />
                            <a class="rr-a-btn mb-8" >Read More <i class="fa-solid fa-circle-plus"></i></a>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6">
                    <div class="service-4__item mb-30">
                        <div class="service-4__item-icon mb-40 mb-xs-20">
                            <img src="assets/imgs/service-4/services__item-2.png" alt="icon not found"/>
                        </div>
                        <div class="service-4__item-text">
                            <h4 class="mb-15 mb-xs-10 title-animation"><a >	Technical Document Update Solutions</a></h4>
                            <p>Technical documentation is an essential set of documents required for each medical device, ensuring compliance with regulatory standards and facilitating market approval.</p>
                            <li>	European MDR Requirements</li>
                            <li>	United States FDA Requirements</li>
                            <li>	China (NMPA) Requirements</li>
                            <li>	Other International Markets</li>
                            <a class="rr-a-btn" >Read More <i class="fa-solid fa-circle-plus"></i></a>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6">
                    <div class="service-4__item mb-30">
                        <div class="service-4__item-icon mb-40 mb-xs-20">
                            <img src="assets/imgs/service-4/services__item-3.png" alt="icon not found"/>
                        </div>
                        <div class="service-4__item-text">
                            <h4 class="mb-15 mb-xs-10 title-animation">	Digital Health Solutions</h4>
                            <p>The growing prevalence of Software as a Medical Device (SaMD) or as part of a device is becoming common and essential in modern healthcare technology and innovation.</p>
                            <br />
                            <li>	Development Processes</li>
                            <li>	Regulatory Landscape</li>
                            <li>	Technical Tools</li>
                            <br/>
                            <a class="rr-a-btn" >Read More <i class="fa-solid fa-circle-plus"></i></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-minus-30" >

            <div class="col-xl-6 col-lg-6 mt-40 ">
                    <div class="service-4__item mb-30">
                        <div class="service-4__item-icon mb-40 mb-xs-20">
                            <img src="assets/imgs/service-4/services__item-2.png" alt="icon not found"/>
                        </div>
                        <div class="service-4__item-text">
                            <h4 class="mb-15 mb-xs-10 title-animation"><a >	Pharmaceutical & Biotech industry</a></h4>
                            <p>Our team members with expertise in CROs and Pharmaceutical & Biotech Industry
                            work together to provide the most effective solutions for you. With years of industry expertise, our team of multidisciplinary specialists is well-equipped to deliver excellent regulatory and high-quality services in a timely manner.
                            </p>
                            <ul>
                                <li>Clinical Investigation Planning</li>
                                <li>Clinical Investigation Project Management</li>
                                <li>Regulatory Submissions</li>
                                <li>Data Management</li>
                                <li>Pharmacovigilance</li>
                                <li>Medical Writing</li>
                                <li>Non-commercial Clinical Trials</li>
                                <li>Clinical Research Sites Network</li>
                                </ul>

                            <a class="rr-a-btn" >Read More <i class="fa-solid fa-circle-plus"></i></a>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 mt-40 ">
                    <div class="service-4__item mb-30">
                        <div class="service-4__item-icon mb-40 mb-xs-20">
                            <img src="assets/imgs/service-4/services__item-2.png" alt="icon not found"/>
                        </div>
                        <div class="service-4__item-text">
                            <h4 class="mb-15 mb-xs-10 title-animation">	Healthcare Providers</h4>
                            <p>Our team comprises a diverse group of healthcare professionals, including experts in Cardiovascular Medicine (Cath-Lab), Ultra-sonography, Dentistry, Orthopedic Surgery, General Practice, and Nursing, along with multidisciplinary clinical specialists. Our team also includes engineering professionals dedicated to MedTech development, ensuring a comprehensive approach to innovation. Together, we bring a unique blend of clinical and technical expertise to advance healthcare solutions. We are committed to addressing complex medical challenges and driving the development of cutting-edge technologies for improved patient outcomes. </p>
                            <ul>
                                <li>Healthcare Consultancy</li>
                                <li>Clinical Research Consultancy</li>
                                <li>Regulatory Consultancy</li>
                                <li>Data Management Consultancy</li>
                            
                                </ul>

                            <a class="rr-a-btn" >Read More <i class="fa-solid fa-circle-plus"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    {/* Products & Service   */}

    <section class="service-4 section-space__bottom-100">
        <div class="container">
        <div class="col-lg-12">
                    <div class="">
                    <h5 class="section__subtitle color-theme-primary mb-15 mb-xs-10 title-animation"><img src="assets/imgs/ask-quesiton/heart.png" alt="icon not found" class="img-fluid"/>Products & Service   </h5>
                      
                    </div>
                </div>
            <div class="row mb-minus-30" >
                <div class="col-xl-4 col-lg-4 col-md-6">
                    <div class="service-4__item mb-30">
                        <div class="service-4__item-icon mb-40 mb-xs-20">
                            <img src="assets/imgs/service-4/services__item-1.png" alt="icon not found"/>
                        </div>
                        <div class="service-4__item-text">
                            <h4 class="mb-15 mb-xs-10 title-animation">	Medical Device consulting</h4>
                            <p>Medical device consulting services guide companies through the complex regulatory landscape, ensuring compliance with global standards. These services include support in product development, regulatory submissions, and quality management systems. </p>
                            <ul>
                                <li>Quality Management System</li>
                                <li>Technical Documentation</li>
                                <li>Post Market Activities</li>
                                <li>Quality Assurance /Regulatory Affairs Service</li>
                                <li>Product Registrations</li>
                                <li>Digital Health Services</li>
                                <li>Data protection</li>
                                <li>Regulatory Life Cycle</li>
                                </ul>
                            <a class="rr-a-btn mb-8" >Read More <i class="fa-solid fa-circle-plus"></i></a>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6">
                    <div class="service-4__item mb-30">
                        <div class="service-4__item-icon mb-40 mb-xs-20">
                            <img src="assets/imgs/service-4/services__item-2.png" alt="icon not found"/>
                        </div>
                        <div class="service-4__item-text">
                            <h4 class="mb-15 mb-xs-10 title-animation"><a >	CRO</a></h4>
                            <p>Our comprehensive CRO services cover Clinical Evaluation, Clinical Investigation, and Post-Market Clinical Follow-up (PMCF) solutions, ensuring your medical device meets regulatory standards throughout its lifecycle. We meticulously plan and execute clinical studies to validate safety and efficacy, adhering to both global and local regulations. Our experts manage data collection, analysis, and reporting to support your regulatory submissions. </p>
                            <ul>
                                <li>Clinical Evaluation</li>
                                <li>Clinical Investigation</li>
                                <li>PMCF Solution</li>
                                
                                </ul>
                            <a class="rr-a-btn" >Read More <i class="fa-solid fa-circle-plus"></i></a>
                         
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6">
                    <div class="service-4__item mb-30">
                        <div class="service-4__item-icon mb-40 mb-xs-20">
                            <img src="assets/imgs/service-4/services__item-3.png" alt="icon not found"/>
                        </div>
                        <div class="service-4__item-text">
                            <h4 class="mb-15 mb-xs-10 title-animation">		Healthcare Consulting</h4>
                            <p>Our consulting services encompass EU MDR, FDA, and NMPA regulations, offering expert guidance to navigate complex compliance requirements. We also specialize in healthcare surveys, gathering critical insights to support regulatory submissions and market strategies. Our team provides comprehensive support in managing submissions to ensure smooth regulatory approval processes.Our goal is to streamline your regulatory journey and provide actionable insights for strategic decision-making. </p>
                            <ul>
  <li>EU MDR/FDA/ NMPA Consulting</li>
  <li>Healthcare Survey</li>
</ul>
                            <a class="rr-a-btn" >Read More <i class="fa-solid fa-circle-plus"></i></a>
                         
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </section>
    
    <div class="brand__area section-space theme-bg-color-100">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="swiper brand__active">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <div class="brand__item text-center">
                                    <div class="brand__thumb">
                                        <img class="img-fluid" src="assets/imgs/brand/brand4.png"  style={{maxWidth:"200px"}} alt="image not found"/>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="brand__item text-center">
                                    <div class="brand__thumb">
                                        <img class="img-fluid" src="assets/imgs/brand/brand5.png" style={{maxWidth:"200px"}} alt="image not found"/>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="brand__item text-center">
                                    <div class="brand__thumb">
                                        <img class="img-fluid" src="assets/imgs/brand/codfty.jpeg" style={{maxWidth:"200px"}} alt="image not found"/>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="brand__item text-center">
                                    <div class="brand__thumb">
                                        <img class="img-fluid" src="assets/imgs/brand/brand5.png" alt="image not found"/>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-slide">
                                <div class="brand__item text-center">
                                    <div class="brand__thumb">
                                        <img class="img-fluid" src="assets/imgs/brand/brand-5.png" alt="image not found"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

  {/* project? */}
   
    <section class="our-projects section-space__bottom">
        <div class="container">
            <div class="row mb-minus-30">
                <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                    <div class="our-projects__item has--title">
                        <div class="section__title-wrapper our-projects__content">
                            <h5 class="section__subtitle color-theme-primary"><img src="assets/imgs/ask-quesiton/heart.png" alt="icon not found" class="img-fluid"/> Our Projects</h5>
                            <h4 class="section__title mb-0 title-animation">Our projects deliver innovative, tailored solutions to meet your unique healthcare needs.</h4>
                        </div>
                        {/* <a href="about-us.html" class="rr-btn">
                        <span class="btn-wrap">
                            <span class="text-one">View All <i class="fa-solid fa-plus"></i></span>
                            <span class="text-two">View All <i class="fa-solid fa-plus"></i></span>
                        </span>
                        </a> */}
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                    <div class="our-projects__item position-relative overflow-hidden">
                        <div class="panel wow"></div>
                        <div class="our-projects__item__content">
                            <div class="our-projects__item__content-media">
                                <img src="assets/imgs/our-project/our-project-1.jpg" class="img-fluid" alt=""/>
                            </div>
                            <div class="our-projects__item__content-icon">
                                {/* <a >
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18.0006 1V14C18.0006 14.2652 17.8952 14.5196 17.7077 14.7071C17.5201 14.8946 17.2658 15 17.0006 15C16.7353 15 16.481 14.8946 16.2934 14.7071C16.1059 14.5196 16.0006 14.2652 16.0006 14V3.41375L1.70806 17.7075C1.52042 17.8951 1.26592 18.0006 1.00056 18.0006C0.735192 18.0006 0.480697 17.8951 0.293056 17.7075C0.105415 17.5199 0 17.2654 0 17C0 16.7346 0.105415 16.4801 0.293056 16.2925L14.5868 2H4.00056C3.73534 2 3.48099 1.89464 3.29345 1.70711C3.10591 1.51957 3.00056 1.26522 3.00056 1C3.00056 0.734784 3.10591 0.48043 3.29345 0.292893C3.48099 0.105357 3.73534 0 4.00056 0H17.0006C17.2658 0 17.5201 0.105357 17.7077 0.292893C17.8952 0.48043 18.0006 0.734784 18.0006 1Z" fill="white"/>
                                    </svg>
                                </a> */}
                            </div>
                            <div class="our-projects__item__content-text">
                                <h4 class="title-animation"><a >Patient Monitor</a></h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                    <div class="our-projects__item position-relative overflow-hidden">
                        <div class="panel wow"></div>
                        <div class="our-projects__item__content">
                            <div class="our-projects__item__content-media">
                                <img src="assets/imgs/our-project/our-project-2.jpg" class="img-fluid" alt=""/>
                            </div>
                            <div class="our-projects__item__content-icon">
                            </div>
                            <div class="our-projects__item__content-text">
                                <h4 class="title-animation">Multiple Module Patient Monitor</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                    <div class="our-projects__item position-relative overflow-hidden">
                        <div class="panel wow"></div>
                        <div class="our-projects__item__content">
                            <div class="our-projects__item__content-media">
                                <img src="assets/imgs/our-project/our-project-3.jpg" class="img-fluid" alt=""/>
                            </div>
                            <div class="our-projects__item__content-icon">
                            </div>
                            <div class="our-projects__item__content-text">
                                <h4 class="title-animation">Predictive Temperature Module</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                    <div class="our-projects__item position-relative overflow-hidden">
                        <div class="panel wow"></div>
                        <div class="our-projects__item__content">
                            <div class="our-projects__item__content-media">
                                <img src="assets/imgs/our-project/our-project-4.jpg" class="img-fluid" alt=""/>
                            </div>
                            <div class="our-projects__item__content-icon">
                            </div>
                            <div class="our-projects__item__content-text">
                                <h4 class="title-animation">	Video Colposcopy Machine</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                    <div class="our-projects__item position-relative overflow-hidden">
                        <div class="panel wow"></div>
                        <div class="our-projects__item__content">
                            <div class="our-projects__item__content-media">
                                <img src="assets/imgs/our-project/our-project-5.jpg" class="img-fluid" alt=""/>
                            </div>
                            <div class="our-projects__item__content-icon">
                            </div>
                            <div class="our-projects__item__content-text">
                                <h4 class="title-animation">Central Monitoring System</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                    <div class="our-projects__item position-relative overflow-hidden">
                        <div class="panel wow"></div>
                        <div class="our-projects__item__content">
                            <div class="our-projects__item__content-media">
                                <img src="assets/imgs/our-project/our-project-5.jpg" class="img-fluid" alt=""/>
                            </div>
                            <div class="our-projects__item__content-icon">
                            </div>
                            <div class="our-projects__item__content-text">
                                <h4 class="title-animation">Ultrasound System</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                    <div class="our-projects__item position-relative overflow-hidden">
                        <div class="panel wow"></div>
                        <div class="our-projects__item__content">
                            <div class="our-projects__item__content-media">
                                <img src="assets/imgs/our-project/our-project-5.jpg" class="img-fluid" alt=""/>
                            </div>
                            <div class="our-projects__item__content-icon">
                            </div>
                            <div class="our-projects__item__content-text">
                                <h4 class="title-animation">AI Object Detection</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 d-flex">
                    <div class="our-projects__item position-relative overflow-hidden">
                        <div class="panel wow"></div>
                        <div class="our-projects__item__content">
                            <div class="our-projects__item__content-media">
                                <img src="assets/imgs/our-project/our-project-5.jpg" class="img-fluid" alt=""/>
                            </div>
                            <div class="our-projects__item__content-icon">
                            </div>
                            <div class="our-projects__item__content-text">
                                <h4 class="title-animation">CI Imaging</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="slider-text">
        <div class="container">
            <div class="rr-scroller" data-speed="slow" data-animated="true">
                <ul class="text-anim rr-scroller__inner">
                    <li><img src="assets/imgs/slider-text/health-guard.png" alt=""/></li>
                    <li><strong>QMS      </strong></li>
                    <li><img src="assets/imgs/slider-text/health-guard.png" alt=""/></li>
                    <li>Health Tech                     </li>
                    <li><img src="assets/imgs/slider-text/health-guard.png" alt=""/></li>
                    <li><strong>Quality                  </strong></li>
                    <li><img src="assets/imgs/slider-text/health-guard.png" alt=""/></li>
                    <li>HealthCare              </li>
                    <li><img src="assets/imgs/slider-text/health-guard.png" alt=""/></li>
                    <li><strong>GCP</strong></li>
                    <li><img src="assets/imgs/slider-text/health-guard.png" alt=""/></li>
                   
                    
                </ul>
            </div>
        </div>
    </div>
   
{/* Appointment Details */}
    <Appoinment/>
    <section class="experience section-space__bottom bg-white">
        <div class="container">
            <div class="experience__item-wrapper">
                <div class="experience__item">
                    <div class="experience__item-content">
                        <div class="experience__item-content-icon">
                            <span>
                                <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_10034_132)">
                                    <path d="M51.6699 9.39453C50.4799 9.39453 49.3261 9.55221 48.2275 9.8461C45.3488 6.13349 40.8969 3.93555 36.1815 3.93555C32.5206 3.93555 29.7041 5.76113 26.9802 7.52667C26.6108 7.76623 26.2331 8.01087 25.855 8.24979C23.023 5.49885 19.1957 3.93555 15.2344 3.93555C10.9883 3.93555 6.90232 5.72876 4.02417 8.85511L5.4251 10.1448C7.94372 7.40886 11.5191 5.83984 15.2344 5.83984C18.5262 5.83984 21.7118 7.07357 24.1469 9.25958C21.5818 10.6481 18.9937 11.4579 17.054 11.4579V13.3622C19.5971 13.3622 23.017 12.2082 26.2021 10.2752C26.8157 9.90285 27.4259 9.50727 28.0162 9.12463C30.6222 7.43539 33.0839 5.83984 36.1815 5.83984C40.0933 5.83984 43.7988 7.56818 46.32 10.5165C41.626 12.5816 38.3399 17.2762 38.3399 22.7245C38.3399 25.0265 38.934 27.2867 40.0607 29.2788V34.3337H44.0494C43.7563 35.278 43.4943 36.2771 43.2628 37.3377L38.8255 39.9161L37.4951 47.7657L41.9306 50.3266C41.9141 51.0303 41.9029 51.75 41.8978 52.4885L43.8021 52.5016C43.8541 44.926 44.5468 39.1021 45.916 34.7502C47.7042 35.606 49.6713 36.0547 51.6701 36.0547C59.0203 36.0547 65.0001 30.0748 65.0001 22.7246C65.0001 15.3744 59.0201 9.39453 51.6699 9.39453ZM39.5938 46.7787L40.5539 41.1143L42.7965 39.8112C42.3983 42.277 42.136 45.043 42.0017 48.1689L39.5938 46.7787ZM51.6699 34.1503C49.6208 34.1503 47.6105 33.6012 45.8564 32.5625L45.6319 32.4295H41.9649V28.7624L41.832 28.5379C40.7932 26.7843 40.2442 24.7741 40.2442 22.7245C40.2442 16.4243 45.3698 11.2987 51.6699 11.2987C57.9701 11.2987 63.0957 16.4243 63.0957 22.7245C63.0957 29.0247 57.9701 34.1503 51.6699 34.1503Z" fill="#071C3C"/>
                                    <path d="M54.5264 17.0115H48.8135V19.8679H45.957V25.5808H48.8135V28.4374H54.5264V25.5809H57.3828V19.868H54.5264V17.0115ZM55.4785 21.7722V23.6765H52.6221V26.5331H50.7178V23.6766H47.8613V21.7723H50.7178V18.9159H52.6221V21.7723H55.4785V21.7722Z" fill="#071C3C"/>
                                    <path d="M36.1815 59.1603C33.0314 59.1603 30.4686 56.5975 30.4686 53.4474C30.4686 49.2406 30.0445 45.6988 29.2421 43.2048C28.1896 39.9331 26.753 39.2464 25.733 39.2464C24.7091 39.2464 23.2639 39.9378 22.1934 43.2312C21.3783 45.7394 20.9473 49.2721 20.9473 53.4474C20.9473 56.5975 18.3845 59.1603 15.2344 59.1603C12.0843 59.1603 9.52148 56.5975 9.52148 53.4474C9.52148 51.3577 9.4622 49.4444 9.35454 47.6839L13.3802 44.2334L13.5091 35.213L16.4845 31.0206L13.0057 24.9997V19.3621L2.32832 15.828C2.72314 14.2977 3.38863 12.8452 4.31095 11.5293L2.75158 10.4363C0.951514 13.0044 0 16.0244 0 19.17C0 23.1476 1.23665 25.7791 2.66868 28.8262C4.87335 33.5175 7.61719 39.3561 7.61719 53.4474C7.61719 57.6475 11.0343 61.0645 15.2344 61.0645C19.4345 61.0645 22.8516 57.6475 22.8516 53.4474C22.8516 44.178 24.9945 41.1507 25.733 41.1507C26.4889 41.1507 28.5643 44.065 28.5643 53.4474C28.5643 57.6475 31.9814 61.0645 36.1815 61.0645C39.9421 61.0645 43.1831 58.2567 43.7205 54.5332L41.8358 54.2611C41.4327 57.0542 39.0019 59.1603 36.1815 59.1603ZM4.39207 28.0161C3.00206 25.0585 1.9043 22.7223 1.9043 19.17C1.9043 18.6825 1.93172 18.1988 1.98352 17.7198L11.1014 20.7378V25.5103L14.2242 30.9152L11.6137 34.5939L11.4886 43.3471L9.17427 45.3309C8.34717 36.4342 6.19569 31.8542 4.39207 28.0161Z" fill="#071C3C"/>
                                    <path d="M39.0381 9.73364H40.9424V11.6379H39.0381V9.73364Z" fill="#071C3C"/>
                                    <path d="M35.2294 7.82935H37.1337V9.73364H35.2294V7.82935Z" fill="#071C3C"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_10034_132">
                                    <rect width="65" height="65" fill="white"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                            </span>
                        </div>
                        <div class="experience__item-content-text">
                            <h2><span class="odometer" data-count="90">90</span>%</h2>
                            <h6 class="title-animation">Happy Clients</h6>
                        </div>
                    </div>
                </div>

                <div class="experience__item">
                    <div class="experience__item-content">
                        <div class="experience__item-content-icon">
                            <span>
                                <svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M41.918 24.7559H43.8223V26.6602H41.918V24.7559Z" fill="#071C3C"/>
                                    <path d="M54.5264 36.952V36.4355C54.5264 34.6642 53.3108 33.1713 51.6699 32.7474V21.8994C51.6699 19.2743 49.5343 17.1387 46.9092 17.1387H43.8223V4.76074C43.8223 3.18563 42.5408 1.9043 40.9659 1.9043H35.1927C34.7996 0.796123 33.7412 0 32.5 0H20.2257C18.6507 0 17.3692 1.28134 17.3692 2.85645V33.3252C17.3692 34.9003 18.6506 36.1816 20.2257 36.1816H25.4107V54.6749C25.4107 59.3181 21.6332 63.0957 16.99 63.0957C12.3468 63.0957 8.56934 59.3182 8.56934 54.6749V39.8696C10.2102 39.4459 11.4258 37.953 11.4258 36.1816V34.6821C12.0492 34.1462 12.624 33.4736 13.1334 32.673C14.4883 30.544 15.2344 27.7323 15.2344 24.7559C15.2344 21.7794 14.4883 18.9677 13.1334 16.8387C11.6935 14.576 9.73451 13.3301 7.61719 13.3301C5.49986 13.3301 3.54085 14.5761 2.10095 16.8387C0.746104 18.9677 0 21.7794 0 24.7559C0 26.9219 0.399648 29.0275 1.15578 30.8449L2.91408 30.1134C2.25342 28.5257 1.9043 26.6731 1.9043 24.7559C1.9043 19.5947 4.52042 15.2344 7.61719 15.2344C10.714 15.2344 13.3301 19.5947 13.3301 24.7559C13.3301 29.917 10.7138 34.2773 7.61719 34.2773C6.17614 34.2773 4.78931 33.3468 3.71198 31.6573L2.10628 32.681C2.61435 33.4779 3.18729 34.1479 3.80859 34.6818V36.1816C3.80859 37.953 5.02417 39.4459 6.66504 39.8698V54.675C6.66504 60.3682 11.2968 65.0001 16.99 65.0001C22.6832 65.0001 27.315 60.3684 27.315 54.675V36.1816H32.5C33.7412 36.1816 34.7995 35.3856 35.1927 34.2773H40.9659C42.5408 34.2773 43.8223 32.996 43.8223 31.4209V28.5645H41.918V31.4209C41.918 31.946 41.4909 32.373 40.9659 32.373H35.3564V3.80859H40.9659C41.4909 3.80859 41.918 4.23566 41.918 4.76074V22.8516H43.8223V19.043H46.9092C48.4842 19.043 49.7656 20.3243 49.7656 21.8994V32.7474C48.1248 33.1713 46.9092 34.664 46.9092 36.4355V36.952C40.8771 38.6229 36.4355 44.161 36.4355 50.7178C36.4355 58.5931 42.8426 65 50.7178 65C58.5929 65 65 58.5931 65 50.7178C65 44.161 60.5584 38.6229 54.5264 36.952ZM5.71289 36.1816V35.832C6.32557 36.0627 6.96389 36.1816 7.61719 36.1816C8.27062 36.1816 8.90881 36.0626 9.52148 35.832V36.1816C9.52148 37.2317 8.66722 38.0859 7.61719 38.0859C6.56716 38.0859 5.71289 37.2317 5.71289 36.1816ZM33.4521 33.3252C33.4521 33.8501 33.0251 34.2773 32.5 34.2773H20.2257C19.7007 34.2773 19.2735 33.8501 19.2735 33.3252V2.85645C19.2735 2.33149 19.7006 1.9043 20.2257 1.9043H32.5C33.0251 1.9043 33.4521 2.33149 33.4521 2.85645V33.3252ZM48.8135 36.4355C48.8135 35.3855 49.6677 34.5312 50.7178 34.5312C51.7678 34.5312 52.6221 35.3855 52.6221 36.4355V36.5628C51.9989 36.4793 51.3635 36.4354 50.7178 36.4354C50.0721 36.4354 49.4367 36.4793 48.8135 36.5628V36.4355ZM50.7178 63.0957C43.8925 63.0957 38.3398 57.5429 38.3398 50.7178C38.3398 43.8926 43.8925 38.3398 50.7178 38.3398C57.543 38.3398 63.0957 43.8925 63.0957 50.7178C63.0957 57.543 57.543 63.0957 50.7178 63.0957Z" fill="#071C3C"/>
                                    <path d="M50.7178 40.2441C44.9427 40.2441 40.2441 44.9425 40.2441 50.7178C40.2441 56.493 44.9427 61.1914 50.7178 61.1914C56.4929 61.1914 61.1914 56.4929 61.1914 50.7178C61.1914 44.9427 56.4929 40.2441 50.7178 40.2441ZM45.3732 57.409L46.6781 56.104L45.3315 54.7576L44.0267 56.0625C43.04 54.8297 42.3861 53.3202 42.2028 51.67H44.0527V49.7658H42.2026C42.386 48.1156 43.0399 46.6061 44.0266 45.3733L45.3315 46.6783L46.6781 45.3318L45.3732 44.0268C46.606 43.04 48.1155 42.3861 49.7656 42.2028V44.0527H51.6699V42.2026C53.3202 42.386 54.8295 43.0399 56.0624 44.0267L54.7573 45.3318L56.1039 46.6783L57.4088 45.3733C58.3955 46.6061 59.0495 48.1156 59.2328 49.7658H57.3828V51.67H59.2329C59.0496 53.3202 58.3956 54.8297 57.409 56.0625L56.104 54.7576L54.7574 56.104L56.0625 57.409C54.5958 58.5828 52.738 59.2871 50.7178 59.2871C48.6976 59.2871 46.8397 58.5828 45.3732 57.409Z" fill="#071C3C"/>
                                    <path d="M53.3109 46.7781L51.9485 48.1405C51.5756 47.9618 51.1582 47.8614 50.7178 47.8614C49.1428 47.8614 47.8613 49.1427 47.8613 50.7178C47.8613 52.2929 49.1428 53.5743 50.7178 53.5743C52.2928 53.5743 53.5742 52.2929 53.5742 50.7178C53.5742 50.2774 53.4738 49.86 53.295 49.4871L54.6575 48.1247L53.3109 46.7781ZM50.7178 51.67C50.1927 51.67 49.7656 51.2428 49.7656 50.7178C49.7656 50.1929 50.1927 49.7657 50.7178 49.7657C51.2429 49.7657 51.6699 50.1927 51.6699 50.7178C51.6699 51.2429 51.2429 51.67 50.7178 51.67Z" fill="#071C3C"/>
                                    <path d="M7.27332 18.0908H9.17761V19.9951H7.27332V18.0908Z" fill="#071C3C"/>
                                    <path d="M9.17761 21.8992H11.0819V23.8035H9.17761V21.8992Z" fill="#071C3C"/>
                                    <path d="M38.1094 9.52148H40.0137V11.4258H38.1094V9.52148Z" fill="#071C3C"/>
                                    <path d="M38.1094 5.71289H40.0137V7.61719H38.1094V5.71289Z" fill="#071C3C"/>
                                </svg>
                            </span>
                        </div>
                        <div class="experience__item-content-text">
                            <h2><span class="odometer" data-count="20">20</span>+</h2>
                            <h6 class="title-animation">Completed Projects       </h6>
                        </div>
                    </div>
                </div>

                <div class="experience__item">
                    <div class="experience__item-content">
                        <div class="experience__item-content-icon">
                            <span>
                                <svg width="49" height="65" viewBox="0 0 49 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.311 55.4785C16.7359 55.4785 15.4546 56.7599 15.4546 58.335C15.4546 59.9101 16.7359 61.1914 18.311 61.1914C19.8861 61.1914 21.1675 59.9101 21.1675 58.335C21.1675 56.7599 19.8861 55.4785 18.311 55.4785ZM18.311 59.2871C17.786 59.2871 17.3589 58.86 17.3589 58.335C17.3589 57.8099 17.786 57.3828 18.311 57.3828C18.8361 57.3828 19.2632 57.8099 19.2632 58.335C19.2632 58.86 18.8361 59.2871 18.311 59.2871Z" fill="#071C3C"/>
                                    <path d="M17.3589 63.0957H19.2632V65H17.3589V63.0957Z" fill="#071C3C"/>
                                    <path d="M48.7798 28.6914C48.7798 21.6614 43.3094 15.8856 36.4019 15.3957V4.76074C36.4019 2.13561 34.2663 0 31.6411 0H4.98096C2.35582 0 0.220215 2.13561 0.220215 4.76074V8.56934H2.12451V5.71289H11.2517L13.156 7.61719H23.4662L25.3705 5.71289H34.4977V15.3957C27.5902 15.8856 22.1198 21.6614 22.1198 28.6914C22.1198 30.9933 22.7139 33.2535 23.8406 35.2456V40.3006H28.8958C30.6127 41.2713 32.5283 41.8457 34.4977 41.9863V51.6699H2.12464V10.4736H0.220342V60.2393C0.220342 62.8644 2.35595 65 4.98108 65H15.4547V63.0957H4.98108C3.40598 63.0957 2.12464 61.8144 2.12464 60.2393V53.5743H34.4977V60.2393C34.4977 61.8144 33.2163 63.0957 31.6412 63.0957H21.1676V65H31.6412C34.2664 65 36.402 62.8644 36.402 60.2393V41.9872C43.3094 41.4973 48.7798 35.7214 48.7798 28.6914ZM24.5818 3.80859L22.6775 5.71289H13.9447L12.0404 3.80859H2.28828C2.68133 2.70042 3.73961 1.9043 4.98096 1.9043H31.6411C32.8825 1.9043 33.9407 2.70042 34.3338 3.80859H24.5818ZM35.4497 40.1172C33.4006 40.1172 31.3904 39.5681 29.6363 38.5294L29.4118 38.3965H25.7446V34.7293L25.6117 34.5048C24.5729 32.7512 24.0238 30.7409 24.0238 28.6914C24.0238 22.3912 29.1494 17.2656 35.4496 17.2656C41.7498 17.2656 46.8754 22.3912 46.8754 28.6914C46.8754 34.9916 41.7499 40.1172 35.4497 40.1172Z" fill="#071C3C"/>
                                    <path d="M40.856 22.2634C39.1034 21.5903 37.1358 22.0788 35.4497 23.566C33.7635 22.0788 31.7957 21.5904 30.0434 22.2634C28.1684 22.9835 26.9569 24.9245 26.9569 27.2086C26.9569 29.3089 27.8609 31.3823 29.5713 33.2046C31.0697 34.8012 33.0528 36.057 35.1552 36.7408L35.4497 36.8365L35.7442 36.7408C37.8467 36.0569 39.8298 34.801 41.3281 33.2046C43.0384 31.3823 43.9425 29.3089 43.9425 27.2086C43.9425 24.9245 42.731 22.9834 40.856 22.2634ZM30.726 24.0411C31.0258 23.926 31.337 23.8694 31.6551 23.8694C32.6716 23.8694 33.7561 24.4478 34.7422 25.5424L35.4496 26.3276L36.1569 25.5424C37.4516 24.1052 38.9158 23.558 40.1732 24.0411C41.3236 24.4828 42.0381 25.6966 42.0381 27.2085C42.0381 27.6217 41.989 28.0282 41.8994 28.426H35.9683L34.9085 29.0963L33.0018 27.2495L31.1418 28.426H28.9997C28.9101 28.0281 28.8611 27.6217 28.8611 27.2085C28.8612 25.6965 29.5758 24.4828 30.726 24.0411ZM35.4497 34.8291C33.2377 34.0351 30.9835 32.3905 29.7701 30.3303H31.6937L32.7535 29.66L34.6602 31.5067L36.5203 30.3301H41.1296C39.916 32.3905 37.6617 34.0351 35.4497 34.8291Z" fill="#071C3C"/>
                                    <path d="M30.689 11.4258H32.5933V13.3301H30.689V11.4258Z" fill="#071C3C"/>
                                    <path d="M30.689 7.61719H32.5933V9.52148H30.689V7.61719Z" fill="#071C3C"/>
                                    <path d="M6.78503 30.1196H18.2108V32.0239H6.78503V30.1196Z" fill="#071C3C"/>
                                    <path d="M6.78503 25.3589H18.2108V27.2632H6.78503V25.3589Z" fill="#071C3C"/>
                                    <path d="M6.78503 34.8804H18.2108V36.7847H6.78503V34.8804Z" fill="#071C3C"/>
                                    <path d="M6.78503 20.5984H18.2108V22.5027H6.78503V20.5984Z" fill="#071C3C"/>
                                </svg>
                            </span>
                        </div>
                        <div class="experience__item-content-text">
                            <h2><span class="odometer" data-count="15">15</span>+</h2>
                            <h6 class="title-animation">Expert Team Members  </h6>
                        </div>
                    </div>
                </div>

                <div class="experience__item">
                    <div class="experience__item-content">
                        <div class="experience__item-content-icon">
                            <span>
                                <svg width="61" height="65" viewBox="0 0 61 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M23.835 63.0957H25.7393V65H23.835V63.0957Z" fill="#071C3C"/>
                                    <path d="M42.9011 3.80859H44.8054V5.71289H42.9011V3.80859Z" fill="#071C3C"/>
                                    <path d="M42.9011 7.61719H44.8054V9.52148H42.9011V7.61719Z" fill="#071C3C"/>
                                    <path d="M59.0875 17.1387C57.5124 17.1387 56.231 15.8572 56.231 14.2822V13.3301H48.6138V0H0.960449V65H21.9307V63.0957H2.86475V1.9043H46.7095V13.3301H39.0923V14.2822C39.0923 15.8572 37.811 17.1387 36.2359 17.1387H35.2837V21.8993C35.2837 26.4551 36.31 30.4388 38.3342 33.7396C40.2969 36.9401 43.1135 39.3583 46.7095 40.9374V55.4785H39.0923V63.0957H27.6436V65H40.4389L48.6138 56.825V40.9381C51.9839 39.4578 54.6752 37.2341 56.6181 34.3192L55.0336 33.263C53.2608 35.9227 50.7821 37.9444 47.6618 39.2766C40.9036 36.3893 37.1882 30.2339 37.1882 21.8993V18.9474C39.0507 18.5677 40.5215 17.0969 40.9012 15.2344H54.4224C54.802 17.0969 56.2729 18.5677 58.1354 18.9474V21.8993C58.1354 25.616 57.3994 28.9176 55.9478 31.7126L57.6378 32.5904C59.2317 29.5216 60.0397 25.9246 60.0397 21.8993V17.1387H59.0875ZM45.3631 57.3828L40.9968 61.7492V57.3828H45.3631Z" fill="#071C3C"/>
                                    <path d="M50.5183 32.0557V29.1992H53.3748V23.4862H50.5183V20.6299H44.8054V23.4862H41.949V29.1992H44.8054V32.0557H50.5183ZM43.8531 27.2949V25.3905H46.7096V22.5342H48.6139V25.3905H51.4703V27.2949H48.6139V30.1514H46.7096V27.2949H43.8531Z" fill="#071C3C"/>
                                    <path d="M17.1699 38.2452V43.3868H32.4043V38.2452C32.4043 35.2584 30.6756 32.6692 28.167 31.4215C29.5806 30.3805 30.5 28.7056 30.5 26.8193V21.1064C30.5 19.5315 29.2187 18.25 27.6436 18.25H21.9307C20.3557 18.25 19.0742 19.5315 19.0742 21.1064V26.8193C19.0742 28.7056 19.9936 30.3805 21.4072 31.4215C18.8986 32.6692 17.1699 35.2584 17.1699 38.2452ZM21.9307 20.1543H27.6436C28.1686 20.1543 28.5957 20.5814 28.5957 21.1064V22.8014L24.7871 22.0397L20.9785 22.8014V21.1064C20.9785 20.5814 21.4057 20.1543 21.9307 20.1543ZM20.9785 26.8193V24.7435L24.7871 23.9818L28.5957 24.7435V26.8193C28.5957 28.9194 26.8872 30.6279 24.7871 30.6279C22.6871 30.6279 20.9785 28.9194 20.9785 26.8193ZM24.7871 32.5322C27.9372 32.5322 30.5 35.0952 30.5 38.2452V41.4825H19.0742V38.2452C19.0742 35.095 21.637 32.5322 24.7871 32.5322Z" fill="#071C3C"/>
                                    <path d="M12.4093 53.8604H37.165V55.7646H12.4093V53.8604Z" fill="#071C3C"/>
                                    <path d="M20.0264 6.34814H29.5479V8.25244H20.0264V6.34814Z" fill="#071C3C"/>
                                    <path d="M12.8854 9.68066H36.689V11.585H12.8854V9.68066Z" fill="#071C3C"/>
                                    <path d="M20.0264 13.4893H29.5479V15.3936H20.0264V13.4893Z" fill="#071C3C"/>
                                    <path d="M12.4093 46.2432H37.165V48.1475H12.4093V46.2432Z" fill="#071C3C"/>
                                    <path d="M12.4093 50.0518H37.165V51.9561H12.4093V50.0518Z" fill="#071C3C"/>
                                </svg>
                            </span>
                        </div>
                        <div class="experience__item-content-text">
                            <h2><span class="odometer" data-count="90">90</span>%</h2>
                            <h6 class="title-animation">Success Rate        </h6>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>

{/* clone icon */}
<OurTherapeuticSpecialties/>



    <section class="pricing-action pricing-action__space" hidden>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="section__title-wrapper pricing-action__content text-center mb-60 mb-xs-50">
                        <h5 class="section__subtitle color-theme-primary mb-15 mb-xs-10 title-animation"><img src="assets/imgs/ask-quesiton/heart.png" alt="icon not found" class="img-fluid"/> Pricing Action</h5>
                        <h2 class="section__title mb-0 text-capitalize title-animation">Empowering wellness one patient at a time</h2>
                    </div>
                </div>
            </div>

            <div class="pricing-action__item">
                <div class="pricing-action__item-content">
                    <div class="pricing-action__item-content__title">
                        <h3 class="title-animation">Basic Plan</h3>
                    </div>
                    <div class="pricing-action__item-content__list">
                        <ul>
                            <li>
                            <span>
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.6875 1.3125C15.0938 1.6875 15.0938 2.34375 14.6875 2.71875L6.6875 10.7188C6.3125 11.125 5.65625 11.125 5.28125 10.7188L1.28125 6.71875C0.875 6.34375 0.875 5.6875 1.28125 5.3125C1.65625 4.90625 2.3125 4.90625 2.6875 5.3125L5.96875 8.59375L13.2812 1.3125C13.6562 0.90625 14.3125 0.90625 14.6875 1.3125Z" fill="#185EC8"/>
                                </svg>
                            </span>
                                Mistakes To Avoid
                            </li>
                            <li>
                            <span>
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.6875 1.3125C15.0938 1.6875 15.0938 2.34375 14.6875 2.71875L6.6875 10.7188C6.3125 11.125 5.65625 11.125 5.28125 10.7188L1.28125 6.71875C0.875 6.34375 0.875 5.6875 1.28125 5.3125C1.65625 4.90625 2.3125 4.90625 2.6875 5.3125L5.96875 8.59375L13.2812 1.3125C13.6562 0.90625 14.3125 0.90625 14.6875 1.3125Z" fill="#185EC8"/>
                                </svg>
                            </span>
                                Your Startup
                            </li>
                            <li>
                            <span>
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.6875 1.3125C15.0938 1.6875 15.0938 2.34375 14.6875 2.71875L6.6875 10.7188C6.3125 11.125 5.65625 11.125 5.28125 10.7188L1.28125 6.71875C0.875 6.34375 0.875 5.6875 1.28125 5.3125C1.65625 4.90625 2.3125 4.90625 2.6875 5.3125L5.96875 8.59375L13.2812 1.3125C13.6562 0.90625 14.3125 0.90625 14.6875 1.3125Z" fill="#185EC8"/>
                                </svg>
                            </span>
                                Knew About Fonts
                            </li>
                        </ul>
                    </div>
                    <div class="pricing-action__item-content__price">
                        <div class="amount">$19
                            <span>/mo</span>
                        </div>
                    </div>
                    <div class="pricing-action__item-content__btn">
                        <a href="pricing.html" class="rr-btn">
                            <span class="btn-wrap">
                                <span class="text-one">Get now </span>
                            <span class="text-two">Get now </span>
                        </span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="pricing-action__item">
                <div class="pricing-action__item-content">
                    <div class="pricing-action__item-content__title">
                        <h3 class="title-animation">Premium Plan</h3>
                    </div>
                    <div class="pricing-action__item-content__list">
                        <ul>
                            <li>
                            <span>
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.6875 1.3125C15.0938 1.6875 15.0938 2.34375 14.6875 2.71875L6.6875 10.7188C6.3125 11.125 5.65625 11.125 5.28125 10.7188L1.28125 6.71875C0.875 6.34375 0.875 5.6875 1.28125 5.3125C1.65625 4.90625 2.3125 4.90625 2.6875 5.3125L5.96875 8.59375L13.2812 1.3125C13.6562 0.90625 14.3125 0.90625 14.6875 1.3125Z" fill="#185EC8"/>
                                </svg>
                            </span>
                                Mistakes To Avoid
                            </li>
                            <li>
                            <span>
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.6875 1.3125C15.0938 1.6875 15.0938 2.34375 14.6875 2.71875L6.6875 10.7188C6.3125 11.125 5.65625 11.125 5.28125 10.7188L1.28125 6.71875C0.875 6.34375 0.875 5.6875 1.28125 5.3125C1.65625 4.90625 2.3125 4.90625 2.6875 5.3125L5.96875 8.59375L13.2812 1.3125C13.6562 0.90625 14.3125 0.90625 14.6875 1.3125Z" fill="#185EC8"/>
                                </svg>
                            </span>
                                Your Startup
                            </li>
                            <li>
                            <span>
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.6875 1.3125C15.0938 1.6875 15.0938 2.34375 14.6875 2.71875L6.6875 10.7188C6.3125 11.125 5.65625 11.125 5.28125 10.7188L1.28125 6.71875C0.875 6.34375 0.875 5.6875 1.28125 5.3125C1.65625 4.90625 2.3125 4.90625 2.6875 5.3125L5.96875 8.59375L13.2812 1.3125C13.6562 0.90625 14.3125 0.90625 14.6875 1.3125Z" fill="#185EC8"/>
                                </svg>
                            </span>
                                Knew About Fonts
                            </li>
                        </ul>
                    </div>
                    <div class="pricing-action__item-content__price">
                        <div class="amount">$69
                            <span>/mo</span>
                        </div>
                    </div>
                    <div class="pricing-action__item-content__btn">
                        <a href="pricing.html" class="rr-btn">
                            <span class="btn-wrap">
                                <span class="text-one">Get now </span>
                            <span class="text-two">Get now </span>
                        </span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="pricing-action__item">
                <div class="pricing-action__item-content">
                    <div class="pricing-action__item-content__title">
                        <h3 class="title-animation">Consult plan</h3>
                    </div>
                    <div class="pricing-action__item-content__list has-consult-plan">
                        <ul>
                            <li>
                            <span>
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.6875 1.3125C15.0938 1.6875 15.0938 2.34375 14.6875 2.71875L6.6875 10.7188C6.3125 11.125 5.65625 11.125 5.28125 10.7188L1.28125 6.71875C0.875 6.34375 0.875 5.6875 1.28125 5.3125C1.65625 4.90625 2.3125 4.90625 2.6875 5.3125L5.96875 8.59375L13.2812 1.3125C13.6562 0.90625 14.3125 0.90625 14.6875 1.3125Z" fill="#185EC8"/>
                                </svg>
                            </span>
                                Mistakes To Avoid
                            </li>
                            <li>
                            <span>
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.6875 1.3125C15.0938 1.6875 15.0938 2.34375 14.6875 2.71875L6.6875 10.7188C6.3125 11.125 5.65625 11.125 5.28125 10.7188L1.28125 6.71875C0.875 6.34375 0.875 5.6875 1.28125 5.3125C1.65625 4.90625 2.3125 4.90625 2.6875 5.3125L5.96875 8.59375L13.2812 1.3125C13.6562 0.90625 14.3125 0.90625 14.6875 1.3125Z" fill="#185EC8"/>
                                </svg>
                            </span>
                                Your Startup
                            </li>
                            <li>
                            <span>
                                <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.6875 1.3125C15.0938 1.6875 15.0938 2.34375 14.6875 2.71875L6.6875 10.7188C6.3125 11.125 5.65625 11.125 5.28125 10.7188L1.28125 6.71875C0.875 6.34375 0.875 5.6875 1.28125 5.3125C1.65625 4.90625 2.3125 4.90625 2.6875 5.3125L5.96875 8.59375L13.2812 1.3125C13.6562 0.90625 14.3125 0.90625 14.6875 1.3125Z" fill="#185EC8"/>
                                </svg>
                            </span>
                                Knew About Fonts
                            </li>
                        </ul>
                    </div>
                    <div class="pricing-action__item-content__price">
                        <div class="amount has--amount">$109
                            <span>/mo</span>
                        </div>
                    </div>
                    <div class="pricing-action__item-content__btn">
                        <a href="pricing.html" class="rr-btn">
                            <span class="btn-wrap">
                                <span class="text-one">Get now </span>
                            <span class="text-two">Get now </span>
                        </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <section class="client-testimonial section-space overflow-hidden">
        <div class="container">
            <div class="client-testimonial__shape"><img class="img-fluid" src="assets/imgs/testimonial/client-testimonial__helth.png" alt="icon not found"/></div>
            <div class="row align-items-end mb-60 mb-sm-50 mb-xs-40">
                <div class="col-lg-7">
                    <div class="section__title-wrapper client-testimonial__content">
                        <h5 class="section__subtitle color-theme-primary mb-15 mb-xs-10 title-animation"><img src="assets/imgs/ask-quesiton/heart.png" alt="icon not found" class="img-fluid"/> Focused Questions</h5>
                        <h2 class="section__title mb-0 title-animation"><b>Precise Inquiries for Clear Insights & Enhanced Understanding</b></h2>
                    </div>
                </div>

                <div class="col-lg-5">
                    <div class="client-testimonial__content-right mt-md-25 mt-sm-25 mt-xs-25">
                        <p class="mb-0"><b>SQUARE MEDTECH provide specific, concise inquiries designed to gather clear and relevant information, enabling precise understanding for effective decision making.</b></p>
                    </div>
                </div>
            </div>

            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="client-testimonial__media">
                        <img class="img-fluid" src="assets/imgs/client-testimonial/client-testimonial.png" alt="icon not found"/>
                    </div>
                </div>

                <div class="col-lg-6">      
                <TestimonialSlider/>
                    {/* <div class="client-testimonial__slider-wrapper">
                        <div class="swiper client-testimonial__slider">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide">
                                    <div class="client-testimonial__item">
                                        <div class="client-testimonial__item-icon mb-30 mb-xs-25">
                                            <img class="img-fluid" src="assets/imgs/client-testimonial/qoute.png" alt="icon not found"/>
                                        </div>

                                        <p class="mb-30 mb-xs-25">Leverage agile frameworks  provide a robust synopsis for strategy foster Leverage a frame works to provide a robust synopsis for strateg fr collaborative thinking to further the overall value prop osition</p>

                                        <div class="client-testimonial__item-author d-flex align-items-center">
                                            <div class="client-testimonial__item-author-thumb">
                                                <img class="img-fluid" src="assets/imgs/client-testimonial/thumb.png" alt="icon not found"/>
                                            </div>
                                            <div class="client-testimonial__item-author-content">
                                                <h5>Jenny Wilson</h5>
                                                <p class="mb-0">Businessman</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="client-testimonial__item">
                                        <div class="client-testimonial__item-icon mb-30 mb-xs-25">
                                            <img class="img-fluid" src="assets/imgs/client-testimonial/qoute.png" alt="icon not found"/>
                                        </div>

                                        <p class="mb-30 mb-xs-25">Leverage agile frameworks  provide a robust synopsis for strategy foster Leverage a frame works to provide a robust synopsis for strateg fr collaborative thinking to further the overall value prop osition</p>

                                        <div class="client-testimonial__item-author d-flex align-items-center">
                                            <div class="client-testimonial__item-author-thumb">
                                                <img class="img-fluid" src="assets/imgs/client-testimonial/thumb.png" alt="icon not found"/>
                                            </div>
                                            <div class="client-testimonial__item-author-content">
                                                <h5>Jenny Wilson</h5>
                                                <p class="mb-0">Businessman</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="client-testimonial__item">
                                        <div class="client-testimonial__item-icon mb-30 mb-xs-25">
                                            <img class="img-fluid" src="assets/imgs/client-testimonial/qoute.png" alt="icon not found"/>
                                        </div>

                                        <p class="mb-30 mb-xs-25">Leverage agile frameworks  provide a robust synopsis for strategy foster Leverage a frame works to provide a robust synopsis for strateg fr collaborative thinking to further the overall value prop osition</p>

                                        <div class="client-testimonial__item-author d-flex align-items-center">
                                            <div class="client-testimonial__item-author-thumb">
                                                <img class="img-fluid" src="assets/imgs/client-testimonial/thumb.png" alt="icon not found"/>
                                            </div>
                                            <div class="client-testimonial__item-author-content">
                                                <h5>Jenny Wilson</h5>
                                                <p class="mb-0">Businessman</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="client-testimonial__slider-dot"></div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    </section>
    <section class="testimonial-2" hidden>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="swiper testimonial-2__slider">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <div class="testimonial-2__item">
                                    <div class="testimonial-2__item-icon mb-35 mb-xs-15">
                                        <img class="img-fluid" src="assets/imgs/testimonial-2/qoute.png" alt="icon not found"/>
                                    </div>
                                    <div class="testimonial-2__item-content mb-35 mb-xs-30">
                                        <h3 class="mb-0">Leverage agile frameworks to provide a rob synopsis for strategy foster Leverage agile frame works to provide a robust synopsi for strategy foster collaborative thinking to further </h3>
                                        <div class="testimonial-2__item-author">
                                            <h4>Jerome Bell</h4>
                                            <p class="mb-0">Fuel Company</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="testimonial-2__slider__arrow d-flex">
                            <div class="testimonial-2__slider__arrow-prev">
                                <svg width="100" height="60" viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="30" cy="30" r="29.5" transform="matrix(-1 0 0 1 60 0)" stroke="#E4E5E5"/>
                                    <path d="M28.9393 28.9393C28.3536 29.5251 28.3536 30.4749 28.9393 31.0607L38.4853 40.6066C39.0711 41.1924 40.0208 41.1924 40.6066 40.6066C41.1924 40.0208 41.1924 39.0711 40.6066 38.4853L32.1213 30L40.6066 21.5147C41.1924 20.9289 41.1924 19.9792 40.6066 19.3934C40.0208 18.8076 39.0711 18.8076 38.4853 19.3934L28.9393 28.9393ZM30 31.5H100V28.5H30V31.5Z" fill="#E4E5E5"/>
                                </svg>
                            </div>

                            <div class="testimonial-2__slider__arrow-next">
                                <svg width="100" height="60" viewBox="0 0 100 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="70" cy="30" r="29.5" stroke="#E4E5E5"/>
                                    <path d="M71.0607 28.9393C71.6464 29.5251 71.6464 30.4749 71.0607 31.0607L61.5147 40.6066C60.9289 41.1924 59.9792 41.1924 59.3934 40.6066C58.8076 40.0208 58.8076 39.0711 59.3934 38.4853L67.8787 30L59.3934 21.5147C58.8076 20.9289 58.8076 19.9792 59.3934 19.3934C59.9792 18.8076 60.9289 18.8076 61.5147 19.3934L71.0607 28.9393ZM70 31.5H0V28.5H70V31.5Z" fill="#E4E5E5"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
<ResourceSection/>
  <LatestBlog/>
</main>
<Footer/>
    </>
  )
}

export default Home